export const countries = [
  { en: "Kuwait", ar: "الكويت" },
  { en: "Saudi Arabia", ar: "المملكة العربية السعودية" },
  { en: "United Arab Emirates", ar: "الإمارات العربية المتحدة" },
  { en: "Qatar", ar: "قطر" },
  { en: "Bahrain", ar: "البحرين" },
  { en: "Oman", ar: "عمان" },
  { en: "Egypt", ar: "مصر" },
  { en: "Jordan", ar: "الأردن" },
  { en: "Lebanon", ar: "لبنان" },
  { en: "Syria", ar: "سوريا" },
  { en: "Iraq", ar: "العراق" },
  { en: "Palestine", ar: "فلسطين" },
  { en: "Yemen", ar: "اليمن" },
  { en: "Sudan", ar: "السودان" },
  { en: "Libya", ar: "ليبيا" },
  { en: "Tunisia", ar: "تونس" },
  { en: "Algeria", ar: "الجزائر" },
  { en: "Morocco", ar: "المغرب" },
  { en: "Mauritania", ar: "موريتانيا" },
  { en: "Somalia", ar: "الصومال" },
  { en: "Djibouti", ar: "جيبوتي" },
  { en: "Comoros", ar: "جزر القمر" },
  { en: "Afghanistan", ar: "أفغانستان" },
  { en: "Albania", ar: "ألبانيا" },
  { en: "Andorra", ar: "أندورا" },
  { en: "Angola", ar: "أنغولا" },
  { en: "Antigua and Barbuda", ar: "أنتيغوا وباربودا" },
  { en: "Argentina", ar: "الأرجنتين" },
  { en: "Armenia", ar: "أرمينيا" },
  { en: "Australia", ar: "أستراليا" },
  { en: "Austria", ar: "النمسا" },
  { en: "Azerbaijan", ar: "أذربيجان" },
  { en: "Bahamas", ar: "جزر البهاما" },
  { en: "Bangladesh", ar: "بغلاديش" },
  { en: "Barbados", ar: "باربادوس" },
  { en: "Belarus", ar: "بيلاروسيا" },
  { en: "Belgium", ar: "بلجيكا" },
  { en: "Belize", ar: "بليز" },
  { en: "Benin", ar: "بنين" },
  { en: "Bhutan", ar: "بوتان" },
  { en: "Bolivia", ar: "بوليفيا" },
  { en: "Bosnia and Herzegovina", ar: "البوسنة والهرسك" },
  { en: "Botswana", ar: "بوتسوانا" },
  { en: "Brazil", ar: "البرازيل" },
  { en: "Brunei", ar: "بروناي" },
  { en: "Bulgaria", ar: "بلغاريا" },
  { en: "Burkina Faso", ar: "بوركينا فاسو" },
  { en: "Burundi", ar: "بوروندي" },
  { en: "Cabo Verde", ar: "الرأس الأخضر" },
  { en: "Cambodia", ar: "كمبوديا" },
  { en: "Cameroon", ar: "الكاميرون" },
  { en: "Canada", ar: "كندا" },
  { en: "Central African Republic", ar: "جمهورية أفريقيا الوسطى" },
  { en: "Chad", ar: "تشاد" },
  { en: "Chile", ar: "شيلي" },
  { en: "China", ar: "الصين" },
  { en: "Colombia", ar: "كولومبيا" },
  { en: "Congo", ar: "الكونغو" },
  { en: "Costa Rica", ar: "كوستاريكا" },
  { en: "Croatia", ar: "كرواتيا" },
  { en: "Cuba", ar: "كوبا" },
  { en: "Cyprus", ar: "قبرص" },
  { en: "Czechia", ar: "جمهورية التشيك" },
  { en: "Denmark", ar: "الدنمارك" },
  { en: "Dominica", ar: "دومينيكا" },
  { en: "Dominican Republic", ar: "جمهورية الدومينيكان" },
  { en: "Ecuador", ar: "الإكوادور" },
  { en: "El Salvador", ar: "السلفادور" },
  { en: "Equatorial Guinea", ar: "غينيا الاستوائية" },
  { en: "Eritrea", ar: "إريتريا" },
  { en: "Estonia", ar: "إستونيا" },
  { en: "Eswatini", ar: "إسواتيني" },
  { en: "Ethiopia", ar: "إثيوبيا" },
  { en: "Fiji", ar: "فيجي" },
  { en: "Finland", ar: "فنلندا" },
  { en: "France", ar: "فرنسا" },
  { en: "Gabon", ar: "الغابون" },
  { en: "Gambia", ar: "غامبيا" },
  { en: "Georgia", ar: "جورجيا" },
  { en: "Germany", ar: "ألمانيا" },
  { en: "Ghana", ar: "غانا" },
  { en: "Greece", ar: "اليونان" },
  { en: "Grenada", ar: "غرينادا" },
  { en: "Guatemala", ar: "غواتيمالا" },
  { en: "Guinea", ar: "غينيا" },
  { en: "Guinea-Bissau", ar: "غينيا بيساو" },
  { en: "Guyana", ar: "غويانا" },
  { en: "Haiti", ar: "هايتي" },
  { en: "Honduras", ar: "هندوراس" },
  { en: "Hungary", ar: "المجر" },
  { en: "Iceland", ar: "آيسلندا" },
  { en: "India", ar: "الهند" },
  { en: "Indonesia", ar: "إندونيسيا" },
  { en: "Iran", ar: "إيران" },
  { en: "Ireland", ar: "أيرلندا" },
  { en: "Italy", ar: "إيطاليا" },
  { en: "Jamaica", ar: "جامايكا" },
  { en: "Japan", ar: "اليابان" },
  { en: "Kazakhstan", ar: "كازاخستان" },
  { en: "Kenya", ar: "كينيا" },
  { en: "Kiribati", ar: "كيريباتي" },
  { en: "Kyrgyzstan", ar: "قيرغيزستان" },
  { en: "Laos", ar: "لاوس" },
  { en: "Latvia", ar: "لاتفيا" },
  { en: "Lesotho", ar: "ليسوتو" },
  { en: "Liberia", ar: "ليبيريا" },
  { en: "Liechtenstein", ar: "ليختنشتاين" },
  { en: "Lithuania", ar: "ليتوانيا" },
  { en: "Luxembourg", ar: "لوكسمبورغ" },
  { en: "Madagascar", ar: "مدغشقر" },
  { en: "Malawi", ar: "ملاوي" },
  { en: "Malaysia", ar: "ماليزيا" },
  { en: "Maldives", ar: "جزر المالديف" },
  { en: "Mali", ar: "مالي" },
  { en: "Malta", ar: "مالطا" },
  { en: "Mauritius", ar: "موريشيوس" },
  { en: "Mexico", ar: "المكسيك" },
  { en: "Moldova", ar: "مولدوفا" },
  { en: "Monaco", ar: "موناكو" },
  { en: "Mongolia", ar: "منغوليا" },
  { en: "Montenegro", ar: "الجبل الأسود" },
  { en: "Mozambique", ar: "موزمبيق" },
  { en: "Myanmar", ar: "ميانمار" },
  { en: "Namibia", ar: "ناميبيا" },
  { en: "Nepal", ar: "النيبال" },
  { en: "Netherlands", ar: "هولندا" },
  { en: "New Zealand", ar: "نيوزيلندا" },
  { en: "Nicaragua", ar: "نيكاراغوا" },
  { en: "Niger", ar: "النيجر" },
  { en: "Nigeria", ar: "نيجيريا" },
  { en: "North Korea", ar: "كوريا الشمالية" },
  { en: "Norway", ar: "النرويج" },
  { en: "Pakistan", ar: "باكستان" },
  { en: "Panama", ar: "بنما" },
  { en: "Paraguay", ar: "باراغواي" },
  { en: "Peru", ar: "بيرو" },
  { en: "Philippines", ar: "الفلبين" },
  { en: "Poland", ar: "بولندا" },
  { en: "Portugal", ar: "البرتغال" },
  { en: "Romania", ar: "رومانيا" },
  { en: "Russia", ar: "روسيا" },
  { en: "Rwanda", ar: "رواندا" },
  { en: "Senegal", ar: "السنغال" },
  { en: "Serbia", ar: "صربيا" },
  { en: "Singapore", ar: "سنغافورة" },
  { en: "Slovakia", ar: "سلوفاكيا" },
  { en: "Slovenia", ar: "سلوفينيا" },
  { en: "South Africa", ar: "جنوب أفريقيا" },
  { en: "South Korea", ar: "كوريا الجنوبية" },
  { en: "South Sudan", ar: "جنوب السودان" },
  { en: "Spain", ar: "إسبانيا" },
  { en: "Sri Lanka", ar: "سريلانكا" },
  { en: "Sweden", ar: "السويد" },
  { en: "Switzerland", ar: "سويسرا" },
  { en: "Taiwan", ar: "تايوان" },
  { en: "Tanzania", ar: "تنزانيا" },
  { en: "Thailand", ar: "تايلاند" },
  { en: "Turkey", ar: "تركيا" },
  { en: "Uganda", ar: "أوغندا" },
  { en: "Ukraine", ar: "أوكرانيا" },
  { en: "United Kingdom", ar: "المملكة المتحدة" },
  { en: "United States", ar: "الولايات المتحدة الأمريكية" },
  { en: "Uruguay", ar: "أوروغواي" },
  { en: "Uzbekistan", ar: "أوزبكستان" },
  { en: "Venezuela", ar: "فنزويلا" },
  { en: "Vietnam", ar: "فيتنام" },
  { en: "Zambia", ar: "زامبيا" },
  { en: "Zimbabwe", ar: "زيمبابوي" },
  { en: "Other", ar: "أخرى" }
];
